import { FunctionComponent, PropsWithChildren, createContext, useMemo } from 'react';

import { EcopilotMonitor } from '../adapters/ecopilot.monitor';
import { NullMonitor } from '../adapters/null.monitor';
import { Monitor } from '../ports/monitor';
import { ENVIRONMENT } from '../variables';

const provide = () => {
    if (['local'].includes(ENVIRONMENT)) {
        return new NullMonitor();
    }
    return new EcopilotMonitor();
};

export const MonitorContext = createContext<{ monitor: Monitor }>({
    monitor: new NullMonitor(),
});

export const MonitorProvider: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <MonitorContext.Provider value={{ monitor: useMemo(provide, []) }}>{children}</MonitorContext.Provider>
);
